<template>
    <transition name="modal">
    <div class="modal-custom-mask">
      <div class="modal-custom-wrapper">
        <div class="modal-custom-container">

          <!-- <div class="modal-custom-header">
            <slot name="header">
              default header
            </slot>
          </div> -->

          <div class="modal-custom-body">
            <slot name="body">
              default body
            </slot>
          </div>

          <div class="modal-custom-footer">
            <slot name="footer">
              default footer
              <button class="modal-default-button" @click="$emit('close')">
                OK
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal'
}
</script>

<style scoped>
.modal-custom-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-custom-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-custom-container {
  width: 400px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-custom-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-custom-body {
  margin: 20px 0 !important;
  font-size: 20px !important;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-custom-enter {
  opacity: 0;
}

.modal-custom-leave-active {
  opacity: 0;
}

.modal-custom-enter .modal-custom-container,
.modal-custom-leave-active .modal-custom-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue